import { Component, Input, Inject, OnDestroy } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { ResponsiveService } from '../responsive.service';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { LayoutService } from '../layout/layout.service';

@Component({
  selector: 'app-balsa-card',
  templateUrl: './balsa-card.component.html',
  styleUrls: ['./balsa-card.component.scss'],
  standalone: false
})
export class BalsaCardComponent implements OnDestroy {
  @Input() title: string;
  @Input() titleIcon: string;
  @Input() subtitle: string;
  @Input() loading: boolean;
  @Input() circleLoading: boolean;
  @Input() cardMargin = '1rem';
  @Input() headerMargin = '0';
  @Input() hasDivider = true;
  @Input() cardShadow = true;
  @Input() useCalculatedMaxHeight = false;
  @Input() minHeight = '0';
  @Input() useMarginBottom = true;
  @Input() additionalHeightOffset = '0px';

  /** Centers the card in the view in a responsive manner */
  @Input() centered = false;
  destroy = new Subject<void>();
  responsiveClass: Observable<string> = this.responsiveService.subject.pipe(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    map((state) => {
      if (state.isLargeIsh && state.isWeb) return 'large';
      return 'small';
    }),
    takeUntil(this.destroy),
  );

  get cardMaxHeightCalculation() {
    if (!this.useCalculatedMaxHeight) {
      return '100%';
    }

    let extraCalculation = '';
    if (this.cardMargin && this.cardMargin !== '0') {
      extraCalculation = ` - ${this.cardMargin}`;
    }

    return 'calc(100vh - ' + this.headerHeight + ' - 350px' + extraCalculation + ' - ' + this.additionalHeightOffset + ')';
  }

  get headerHeight() {
    return this.layoutService.layoutHeightOffsetTop + 'px';
  }

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private readonly responsiveService: ResponsiveService,
    private readonly layoutService: LayoutService,
  ) {}

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
